import alsalama from "../assets/sponsors/alsalama.png"
import arcite_white from "../assets/sponsors/arcite_white.png"
import bbqn from "../assets/sponsors/bbqn.png"
import educareer from "../assets/sponsors/educareer.png"
import metcon from "../assets/sponsors/metcon.png"
import wrench from "../assets/sponsors/wrench.png"

const Sponsors = () => {
    return (
        <div className="mb-24 px-20 sm:mb-4 lg:px-4">
            <div className="flex justify-center w-full">
                <h3 className="text-3xl font-bold sm:text-md">Our Sponsors</h3>
            </div>
            <div className="flex flex-wrap justify-center items-center w-full py-14 sm:py-10">
                <a className="m-8 lg:m-4" href="https://www.barbequenation.com/" target="_blank" rel="noreferrer"><img className="h-14 sm:h-8" src={bbqn} alt="Sponsor" /></a>
                <a className="m-8 lg:m-4" href="https://www.educareerindia.com/" target="_blank" rel="noreferrer"><img className="h-14 sm:h-8" src={educareer} alt="Sponsor" /></a>
                <a className="m-8 lg:m-4" href="https://www.wrenchsp.com/" target="_blank" rel="noreferrer"><img className="h-14 sm:h-8" src={wrench} alt="Sponsor" /></a>
                <a className="m-8 lg:m-4" href="https://www.metconindia.com/index.php" target="_blank" rel="noreferrer"><img className="h-14 sm:h-8" src={metcon} alt="Sponsor" /></a>
                <a className="m-8 lg:m-4" href="https://www.arcite.in/school_technical_edu/home" target="_blank" rel="noreferrer"><img className="h-14 sm:h-8" src={arcite_white} alt="Sponsor" /></a>
                <a className="m-8 lg:m-4" href="https://alsalamahotels.in/" target="_blank" rel="noreferrer"><img className="h-14 sm:h-8" src={alsalama} alt="Sponsor" /></a>
            </div>
        </div>
    )
}

export default Sponsors